export const mutationType = {
  GET_LISTS: 'GET_LISTS',
}
